import { createContext } from "react";

const ConfirmDialogContext = createContext({
  confirm: () => Promise.resolve(false),
});
export default ConfirmDialogContext;
